import { render } from "./LoaderSpinner.vue?vue&type=template&id=10282d50"
import script from "./LoaderSpinner.vue?vue&type=script&lang=js"
export * from "./LoaderSpinner.vue?vue&type=script&lang=js"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__